<template>
    <div class="payment-success-page">
        <!-- 头部组件 -->
        <Header />

        <div class="content-wrapper">
            <!-- 面包屑导航 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right" v-if="is_from == 1">
                    <el-breadcrumb-item :to="{
                        name: 'home', params: {
                            activeName: '2',
                        },
                    }">供应大厅</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.go(-2)">商品详情</el-breadcrumb-item>
                    <el-breadcrumb-item>支付结果</el-breadcrumb-item>
                </el-breadcrumb>

                <el-breadcrumb separator-class="el-icon-arrow-right" v-if="is_from == 2">
                    <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>发布成功</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 支付成功内容区域 -->
            <div class="success-content">
                <div class="success-icon-container">
                    <div class="success-icon">
                        <!-- <i class="el-icon-circle-check"></i> -->
                        <img src="@/assets/images/30.png" alt="">
                    </div>
                </div>
                <div class="success-message" v-if="is_from == 1">订单支付成功！</div>
                <div class="success-message" v-if="is_from == 2">发布推广成功！</div>
                <div class="order-info">
                    <div class="info-item">
                        <span class="label">订单金额：</span>
                        <span class="value">¥{{ orderAmount }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">支付方式：</span>
                        <span class="value">{{ paymentMethod }}</span>
                    </div>
                </div>
                <div class="action-buttons">
                    <el-button class="back-home-button" @click="goBackHome">返回首页</el-button>
                    <el-button type="primary" class="view-order-button" @click="viewOrder"
                        v-if="is_from == 1">查看订单</el-button>
                </div>
            </div>
        </div>

        <!-- 底部组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入头部和底部组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'

export default {
    name: 'PaymentSuccessPage',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            // 订单信息
            orderId: '',
            orderAmount: '406.00', // 默认值，实际应该从路由参数或API获取
            paymentMethod: '微信支付', // 默认值，实际应该从路由参数或API获取
            orderSn: '',
            is_from: this.$route.query.is_from || 1, // 1是购买商品，2是推广

        }
    },
    created() {
        // 从路由参数获取订单信息
        this.orderSn = this.$route.query.order_sn || ''
        this.getOrderPayInfo()
    },
    methods: {
        // 返回首页
        goBackHome() {
            this.$router.push('/')
        },
        // 查看订单
        viewOrder() {
            // 跳转到订单详情页，需要根据实际路由配置修改
            this.$router.push({
                path: '/buyer',
                query: { componentName: 'MyOrders' }
            })
        },
        // 获取订单支付信息
        getOrderPayInfo() {
            this.$api.getOrderPayInfo({
                order_sn: this.orderSn
            }).then(res => {
                // 处理成功逻辑
                this.orderAmount = res.payable_money
                this.paymentMethod = res.pay_type
            }).catch(err => {
                this.$message.error(err)
            })
        }
    }
}
</script>

<style scoped>
.payment-success-page {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
}

.breadcrumb {
    padding: 24px 0 20px 0;
}

/* 支付成功内容区域样式 */
.success-content {
    background-color: #fff;
    padding: 60px 40px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: center;
    margin: 0 auto;
    /* max-width: 600px; */
}

.success-icon-container {
    margin-bottom: 30px;
}

.success-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    border-radius: 50%;
    /* background-color: #f0f9eb; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 3px solid #c2e7b0; */
}

.success-icon img {
    width: 90px;
    height: 64px;
}

.success-message {
    font-size: 24px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 40px;
}

.order-info {
    margin-bottom: 50px;
    padding: 0 40px;
}

.info-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-item .label {
    font-size: 16px;
    color: #606266;
    margin-right: 12px;
}

.info-item .value {
    font-size: 16px;
    color: #303133;
    font-weight: 500;
}

.action-buttons {
    display: flex;
    justify-content: center;
    gap: 30px;
}

.back-home-button,
.view-order-button {
    width: 160px;
    height: 44px;
    font-size: 16px;
    border-radius: 4px;
}

.back-home-button {
    border: 1px solid #dcdfe6;
    color: #606266;
}

.view-order-button {
    background-color: #286CED;
    border-color: #286CED;
}

.view-order-button:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
}
</style>